import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Text } from '../typography';
import PlainLink from '../NavLink';

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 },
    },
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 },
    },
  },
};

export const ListItem = styled(motion.li)`
  margin: 0;
  padding: 0;
  opacity: 0.8;
  list-style: none;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Item = styled(Text.withComponent(PlainLink))`
  border-radius: 5px;
  font-size: 1.2em;
  text-decoration: none;
`;

export const MenuItem = ({ to, label, onClick }) => (
  <ListItem
    variants={variants}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
  >
    <Item to={to} onClick={onClick}>
      {label}
    </Item>
  </ListItem>
);
